import React, { ReactElement, KeyboardEvent } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import { getClassNames } from '../../../../utils/util';

import './checkbox.scss';

type Props = {
  label?: string;
  name?: string;
  value: boolean;
  onChange: (value: boolean) => void;
  left?: boolean;
  disabled?: boolean;
};

const Checkbox = ({ label, name, value, onChange, left = false, disabled = false }: Props): ReactElement => {
  return (
    <div className="checkbox">
      {left && <Box name={name} value={value} onChange={onChange} left={left} disabled={disabled} />}
      <div className="checkbox__label-container">
        <label>{label}</label>
      </div>
      {!left && <Box name={name} value={value} onChange={onChange} left={left} disabled={disabled} />}
    </div>
  );
};

type BoxProps = Omit<Props, 'label'>;

const Box = ({ name, value, onChange, left = false, disabled = false }: BoxProps): ReactElement => {
  const handleClick = (): void => {
    if (!disabled) {
      onChange(!value);
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>): void => {
    if (!disabled && event.key === 'Enter') {
      onChange(!value);
    }
  };

  return (
    <div
      className={getClassNames('checkbox__icon-container', { left, disabled })}
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      data-testid={name}
    >
      {value && <FontAwesomeIcon icon={faCheck} />}
    </div>
  );
};

export default Checkbox;
